export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tagViewItem.vue?vue&type=template&id=7282160f&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/tagViewItem.vue?vue&type=template&id=7282160f&
// module id = 496
// module chunks = 30